export default __webpack_public_path__ + "static/slide2-en@2x-d0f2f2f8fc84ffcd929fe9354b6bb574.png";